// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js","385":"component---src-templates-using-dsg-js"}[chunkId] + "-" + {"125":"0894af3ecdce8dfeea15","223":"e6e3811b38b3053f9289","293":"ef3c1eca0171b7151d2b","385":"f7feda666c502952b9cd"}[chunkId] + ".js";
};